



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ValidationErrorDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  showDialog!: boolean;

  @Prop({ type: String, default: "" })
  title!: string;

  @Prop({ type: String, default: "" })
  detail!: string;

  close() {
    this.$emit("close");
  }
}
